import { render, staticRenderFns } from "./details_row.vue.js?vue&type=template&id=a0fcb6f0!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_row.vue?vue&type=template&id=a0fcb6f0"
import script from "./details_row.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_row.vue?vue&type=script&lang=js"
export * from "./details_row.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./details_row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports